import { useEffect, useState } from "react";
import { genericListboxFetch } from "./DropdownDataProviders";
import { Globals } from "root/DataFunctions/BaseDataFns";

const useListboxFetch = ( { url, keyFieldName, labelFieldName, additionalFields, filterFn } ) =>
{
    const [ data, setData ] = useState ( { loading: true, items: [] } );

    useEffect ( () =>
    {
        genericListboxFetch ( { url: Globals.APIFolder + url, keyFieldName, labelFieldName, additionalFields, filterFn }).then ( ( response ) =>
        {
            setData ( { loading: false, items: response } );
        } );

    }, [] );

    return [ data.loading, data.items ]
}

export default useListboxFetch ;